/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') !== null &&
         localStorage.getItem('jwt') !== null
}

/**
 * Return if user is a Platinum member
 * Checks the cached user data in localStorage
 */
export const isUserPlatinum = () => {
  try {
    const userData = localStorage.getItem('userData')
    if (!userData) return false

    const user = JSON.parse(userData)

    return user.isPlatinum === true
  } catch (error) {
    console.error('Error checking Platinum status:', error)

    return false
  }
}

/**
 * Return if the user is a platform ("RM") admin.
 * Platform admins have userLevel === 'admin'. Mirrors the server-side
 * isPlatformAdmin() check (lib/permissions/authorizationService.js) so
 * admin-only authoring surfaces (tag admin, member admin) can be gated in the
 * router. Client-side convenience gate only — the API still enforces
 * requireAdmin() on every admin endpoint.
 */
export const isPlatformAdmin = () => {
  try {
    const userData = localStorage.getItem('userData')
    if (!userData) return false

    return JSON.parse(userData).userLevel === 'admin'
  } catch {
    return false
  }
}

const RESTAURANT_ADMIN_PERMISSIONS = ['admin', 'owner', 'adminStandard']
const RESTAURANT_ADMIN_GROUP_TYPES = ['restaurant', 'restaurantGroup']

/**
 * Return if the user is eligible for Restaurant Admin mode.
 * Mirrors the canUseRestaurantAdminMode logic for use in the router guard
 * (Pinia stores are not reliably available during early navigation).
 */
export const isRestaurantAdminEligible = () => {
  try {
    const userData = localStorage.getItem('userData')
    if (!userData) return false

    const user = JSON.parse(userData)
    if (user.userLevel === 'admin') return true

    const groups = user.userGroups || []
    const email = user.email

    return groups.some(
      group =>
        RESTAURANT_ADMIN_GROUP_TYPES.includes(group.type) &&
        (group.userPermissions || []).some(
          p => p.email === email && RESTAURANT_ADMIN_PERMISSIONS.includes(p.permission),
        ),
    )
  } catch {
    return false
  }
}
